document.addEventListener('DOMContentLoaded', function() {
  const elementToRotate = document.querySelector('.element-to-rotate'); 

  if (!elementToRotate) return;

  window.addEventListener('scroll', function() {
    const scrollPosition = window.pageYOffset;
    const rotationAngle = scrollPosition * 0.2; // Adjust the rotation speed as needed

    elementToRotate.style.transform = `rotate(${rotationAngle}deg)`;
  });
});